import React from 'react';
import { FormControl, FormLabel } from '@mui/material';
import { ImportStatusPicker } from './ImportStatusPicker';
import { ImportTypePicker } from './ImportTypePicker';

// The history's filters, each sent to the backend as a list (see imports/list)
const FILTERS = [
	{ field: 'importType', label: 'Type', Picker: ImportTypePicker },
	{ field: 'status', label: 'Status', Picker: ImportStatusPicker },
];

/**
 * The import history's filters, one element per filter for AdminListToolbar. Each has "All"
 * and "Clear Filter" options. Values are saved in the admin table prefs through
 * useAdminListParams' filters / setFilter, and sent with the list request.
 */
export const getImportFilters = ({ filters, setFilter }) =>
	FILTERS.map(({ field, label, Picker }) => (
		<FormControl key={field} fullWidth>
			<FormLabel>{label}</FormLabel>
			<Picker
				value={filters[field] ?? []}
				onChange={(values) => setFilter(field, values.length ? values : undefined)}
				showCheckbox
				showAllOption
				showClearOption
			/>
		</FormControl>
	));
